export default (() => ({
  1100: 'auth.unauthorized',
  1101: 'auth.invalid.grant',
  1102: 'auth.invalid.user',
  1103: 'auth.invalid.key',
  1110: 'auth.user.action.required',
  1120: 'auth.invalid.idp',
  1130: 'auth.session.not.found',
  1131: 'auth.user.already.authenticated',
  1201: 'auth.user.already.exists',
  1202: 'auth.user.password.policy.not.met',
  1301: 'auth.unsupported.action',
  1302: 'auth.action.token.expired',
}))();
